import BaseService from '@/services/BaseService';

class CustomerService extends BaseService {
    viewCustomer = (id) => this.get(`/view-customer/${id}`);

    createCustomer = (data) => this.post('/create-customer', data);

    getCustomerList = (data) => this.post(
        `/get-customer-list?page=${data.page}&per_page=${data.per_page}`,
        data || {},
    );

    updateCustomer = (data, id) => this.post(`/edit-customer/${id}`, data);

    changeCustomerStatus = (data) => this.post('/update-customer-status', data);

    getCountryList = () => this.get('/get-country-list');

    getCompanyListOptions = (data) => this.post('/get-company-list-options', { search: data?.search } || {});

    deleteCustomer = (id) => this.delete(`/delete-customer/${id}`);

    getCustomerProjectList = (data, customerId) => this.post(`/get-customer-project-list/${customerId}`, data || {});

    downloadCustomerData = (data) => this.post('/download-customer-data', data);

    uploadCustomerData = (data) => {
        return this.api.post(
            '/upload-customer-data',
            data,
            {
                headers: { 'Content-Type': 'multipart/form-data' },
            },
        );
    };
}

export default new CustomerService();
